import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

import { DeliveryHourRows } from "./deliveryHourRows";
import { DeliveryHourEditRows } from "./deliveryHourEditRows";
import { isPoolTimesValid } from "../../../../helpers/poolTime";
import { loadDeliveryHoursAsync, saveDeliveryHoursAsync, updateEditDeliveryHours, gotoEditMode } from "../../../../actions/deliveryHours";
import { daysOfTheWeek } from "../../../../helpers/week";

import "./styles.css";
import Loader from "../../../../components/loader";
import Error from "../../../../components/alerts/error";

export class DeliveryHours extends React.Component {
  constructor(props) {
    super(props);

    this.submitDeliveryHours = this.submitDeliveryHours.bind(this);
    this.updateEditDeliveryHoursRow = this.updateEditDeliveryHoursRow.bind(this);
  }

  componentDidMount() {
    this.props.loadDeliveryHoursAsync(this.props.id);
  }

  getWeekRows() {
    if (this.props.deliveryHours) {
      return daysOfTheWeek.map((dayName, index) => <DeliveryHourRows key={index} row={this.props.deliveryHours[dayName]} dayName={dayName} />);
    }

    return [];
  }

  updateEditDeliveryHoursRow(deliveryHoursRow, dayName) {
    let newObject = {};
    Object.assign(newObject, this.props.editDeliveryHours);
    newObject[dayName] = deliveryHoursRow;

    this.props.updateEditDeliveryHours(newObject);
  }

  getWeekEditRows() {
    return daysOfTheWeek.map((dayName, index) => (
      <DeliveryHourEditRows
        key={index}
        row={this.props.editDeliveryHours[dayName]}
        dayName={dayName}
        onChange={this.updateEditDeliveryHoursRow}
        supportMultipleHours={this.props.supportMultipleHours}
      />
    ));
  }

  isEditDeliveryHoursValid() {
    for (let dayOfWeek in this.props.editDeliveryHours) {
      if (this.props.editDeliveryHours.hasOwnProperty(dayOfWeek)) {
        let current = this.props.editDeliveryHours[dayOfWeek];
        if (isPoolTimesValid(current.poolTimes, current.closed) === false) {
          return false;
        }
      }
    }
    return true;
  }

  submitDeliveryHours() {
    if (!this.isEditDeliveryHoursValid()) {
      return;
    }
    this.props.saveDeliveryHoursAsync(this.props.poolId, this.props.editDeliveryHours);
  }

  render() {
    let rows;
    if (this.props.error !== undefined) {
      rows = (
        <tbody>
          <tr>
            <td colSpan={5}>
              <Error title="Error loading delivery hours" body={this.props.error} />
            </td>
          </tr>
        </tbody>
      );
    } else if (this.props.isLoading || this.props.isSaving) {
      rows = (
        <tbody>
          <tr>
            <td colSpan={5}>
              <Loader />
            </td>
          </tr>
        </tbody>
      );
    } else {
      rows = this.props.editMode ? this.getWeekEditRows() : this.getWeekRows();
    }

    return (
      <div>
        <div className="row switchMode">
          <div className="col-lg-5 col-sm-12">
            <h3 className="pull-left"> Delivery Hours</h3>
          </div>
          {this.props.editMode ? (
            <div>
              <button id="CancelDeliveryHours" className="btn btn-sm btn-secondary margin-right-5" onClick={() => this.props.gotoEditMode(false)}>
                Cancel
              </button>
              <button id="SaveDeliveryHours" className="btn btn-sm btn-success" disabled={!this.isEditDeliveryHoursValid()} onClick={this.submitDeliveryHours}>
                Save
              </button>
            </div>
          ) : (
            <div>
              <button id="EditDeliveryHours" className="btn btn-sm btn-primary" onClick={() => this.props.gotoEditMode(true)}>
                Edit
              </button>
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <table className={"table table-striped table-hover"}>
              <thead>
                <tr>
                  <th>Day</th>
                  <th>Opening Time</th>
                  <th>Closing Time</th>
                  <th>Closed</th>
                  <th>{this.props.editMode && this.props.supportMultipleHours ? "Add/Remove" : ""}</th>
                </tr>
              </thead>
              {this.props.saveError && (
                <tbody>
                  <tr>
                    <td colSpan={5}>
                      <Error title="Error Saving delivery hours" body={this.props.saveError} />
                    </td>
                  </tr>
                </tbody>
              )}
              {rows}
            </table>
          </div>
        </div>
      </div>
    );
  }
}

DeliveryHours.propTypes = {
  deliveryHours: PropTypes.object,
  editDeliveryHours: PropTypes.object,
  loadDeliveryHoursAsync: PropTypes.func.isRequired,
  updateEditDeliveryHours: PropTypes.func.isRequired,
  saveDeliveryHoursAsync: PropTypes.func.isRequired,
  saveError: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool,
  editMode: PropTypes.bool,
  error: PropTypes.object,
  poolId: PropTypes.string,
  supportMultipleHours: PropTypes.bool,
  id: PropTypes.string,
  gotoEditMode: PropTypes.func,
};

const mapStateToProps = (state, props) => {
  let newProps = {
    ...props,
    poolId: state.deliveryHours.poolId,
    deliveryHours: state.deliveryHours.data,
    editDeliveryHours: state.deliveryHours.editDeliveryHours,
    isLoading: state.deliveryHours.isLoading,
    isSaving: state.deliveryHours.isSaving,
    editMode: state.deliveryHours.editMode,
    error: state.deliveryHours.error,
    saveError: state.deliveryHours.saveError,
    supportMultipleHours: window.env.supportMultipleHours[state.system.tenant],
  };
  return newProps;
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadDeliveryHoursAsync,
      saveDeliveryHoursAsync,
      updateEditDeliveryHours,
      gotoEditMode,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryHours);



// WEBPACK FOOTER //
// ./src/containers/pools/details/deliveryHours/index.js